<template>
  <Main
    :tableData="tableData"
    :loading="loading"
    :current-key="currentKey"
    ref="main"
    @current-change="(row) => $emit('change', row)"
  >
    <template #header>
      <div class="side-frame-success">
        <span class="side-frame-text">运单明细</span>
      </div>
    </template>
  </Main>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    listSoBillCode: { type: Array, default: () => [] },
    listSoBillDetailCode: { type: Array, default: () => [] },
    currentKey: { type: String, default: '' },
  },
  data() {
    return { tableData: [], loading: false }
  },
  async mounted() {
    await this.getData()
    this.$refs.main.setFirstCurrentRow()
  },
  methods: {
    async getData() {
      this.tableData = []

      const code = this.listSoBillCode.concat(this.listSoBillDetailCode)
      if (!code || !code.length) return

      this.loading = true
      const res = await this.$api
        .finSoBillListWaybillApi({
          listSoBillCode: this.listSoBillCode,
          listSoBillDetailCode: this.listSoBillDetailCode,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.tableData = res.body.data
    },
  },
}
</script>
